import 'css-chunksrc/client/common/modal/styles.scss';export default {
  "modal": "_modal_vfpax_1",
  "header": "_header_vfpax_9",
  "title": "_title_vfpax_19",
  "iconBox": "_iconBox_vfpax_27",
  "icon": "_icon_vfpax_27"
};